<form [formGroup]="inspectionDataFormGroup">
  <fieldset
    class="border rounded-3 p-3"
    *ngIf="[0, 1, 2].indexOf(component_mawp.strD_iclass) !== -1"
  >
    <legend
      class="subtitle-4 float-none w-auto px-3"
      *ngIf="component_mawp.strD_iclass == 0"
    >
      Type of Analysis
    </legend>
    <legend
      class="subtitle-4 float-none w-auto px-3"
      *ngIf="component_mawp.strD_iclass == 1 || component_mawp.strD_iclass == 2"
    >
      Type of Metal Loss
    </legend>
    <div class="container">
      <div class="form-group row align-items-center">
        <div class="col-sm-6 align-self-center">
          <input
            type="radio"
            id="inspection-radioButton1_DI"
            name="inspection-radioButton_DI"
            formControlName="radioButton_DI"
            value="radioButton1_DI_enabled"
            (change)="onChangeRadioButton1_DI($event.target.value)"
          />
          <label for="inspection-radioButton1_DI" *ngIf="component_mawp.strD_iclass == 0"
            >&nbsp;Average measured thickness</label
          >
          <label
            for="inspection-radioButton1_DI"
            *ngIf="
              component_mawp.strD_iclass == 1 || component_mawp.strD_iclass == 2
            "
            >&nbsp;Local Thin Area (LTA)</label
          >
          <label for="inspection-radioButton1_DI" *ngIf="component_mawp.strD_iclass == 5"
            >&nbsp;Blister</label
          >
        </div>
        <div class="col-sm-6">
          <input
            type="radio"
            id="inspection-radioButton2_DI"
            name="inspection-radioButton_DI"
            formControlName="radioButton_DI"
            value="radioButton2_DI_enabled"
            (change)="onChangeRadioButton1_DI($event.target.value)"
          />
          <label for="inspection-radioButton2_DI" *ngIf="component_mawp.strD_iclass == 0">
            &nbsp;{{ component_maep?.strRadio === 1 ? 'MAEP' : 'MAWP and MFH' }}
          </label>
          <label
            for="inspection-radioButton2_DI"
            *ngIf="
              component_mawp.strD_iclass == 1 || component_mawp.strD_iclass == 2
            "
            >&nbsp;Groove</label
          >
          <label for="inspection-radioButton2_DI" *ngIf="component_mawp.strD_iclass == 5"
            >&nbsp;HIC Damage</label
          >
        </div>
      </div>
    </div>
  </fieldset>
  <fieldset
    class="border rounded-3 p-3"
    *ngIf="component_mawp.strD_class === 'Lamination'"
  >
  <legend> </legend>
    <div class="container">
      <div class="form-group row align-items-center">
        <div class="col-sm-8 align-self-center">
          <label for="comboBox1_DI_Equip_Hyd"
            >Any surface bulging on either the inside or the outside of the
            component at the location of the lamination?</label
          >
        </div>
        <div class="col-sm-4">
          <select
            id="comboBox1_DI_Equip_Hyd"
            class="form-control form-control-sm"
            (change)="onChangeComboBox1_DI_Equip_Hyd($event)"
            formControlName="comboBox1_DI_Equip_Hyd"
          >
            <option value="Initial" disabled selected hidden></option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </div>
      </div>
      <div
        class="form-group row align-items-center"
        *ngIf="div_for_comboBox2_DI_Equip_Hyd_visible"
      >
        <div class="col-sm-8 align-self-center">
          <label for="comboBox2_DI_Equip_Hyd"
            >Is the equipment in hydrogen charging service?</label
          >
        </div>
        <div class="col-sm-4">
          <select
            id="comboBox2_DI_Equip_Hyd"
            class="form-control form-control-sm"
            (change)="onChangeComboBox2_DI_Equip_Hyd($event)"
            formControlName="comboBox2_DI_Equip_Hyd"
          >
            <option value="Initial" disabled selected hidden></option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </div>
      </div>
      <div
        class="form-group row align-items-center"
        *ngIf="div_for_comboBox3_DI_Equip_Hyd_visible"
      >
        <div class="col-sm-8 align-self-center">
          <label for="comboBox3_DI_Equip_Hyd"
            >Any cracks extending from lamination in the through-thickness
            direction?</label
          >
        </div>
        <div class="col-sm-4">
          <select
            id="comboBox3_DI_Equip_Hyd"
            class="form-control form-control-sm"
            (change)="onChangeComboBox3_DI_Equip_Hyd($event)"
            formControlName="comboBox3_DI_Equip_Hyd"
          >
            <option value="Initial" disabled selected hidden></option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </div>
      </div>
    </div>
  </fieldset>
  <fieldset
    class="border rounded-3 p-3"
    *ngIf="fieldSetVisible() && [6].indexOf(component_mawp.strD_iclass) == -1"
  >
    <legend class="subtitle-4 float-none w-auto px-3">
      Component Information
    </legend>
    <div class="container">
      <div class="result mb-5">
        <p [innerHTML]="MAWP_result"></p>
      </div>
      <div
        class="form-group row align-items-center"
        *ngIf="
          component_mawp.strD_iclass === 7 && !DentInPressurizedCondition()
        "
      >
        <div class="col-sm-8 align-self-center">
          <label for="textBox1_DI_EquipInfo"
            >Maximum operating pressure, P_op&nbsp;<span
              *ngIf="this.intUnit === 0"
              >(psi)</span
            ><span *ngIf="this.intUnit === 1">(MPa)</span>:</label
          >
        </div>
        <div class="col-sm-4">
          <input
            appRestrictInput
            type="number"
            name="maxOperatingPressure"
            (change)="onChangeTextBox1_DI_EquipInfo($event)"
            id="textBox1_DI_EquipInfo"
            class="form-control form-control-sm"
            formControlName="textBox1_DI_EquipInfo"
            min="0"
          />
        </div>
      </div>
      <validation
        *ngIf="[8].indexOf(component_mawp.strD_iclass) !== -1"
        [ValidationList]="validation_list_ComponentInformation"
        [ValidationLabel]="basicValidationLabel"
      ></validation>
      <component-information
        *ngIf="[8].indexOf(component_mawp.strD_iclass) !== -1"
        (comboBox2_DI_EnabledEvent)="comboBox2_DI_Enabling($event)"
        (textBox4_DI_EnabledEvent)="textBox4_DI_Enabling($event)"
        [componentData]="componentData"
        [checkValidation]="componentInformationValidation"
      ></component-information>
    </div>
  </fieldset>
  <fieldset
    class="border rounded-3 p-3"
    *ngIf="component_mawp.strD_class !== 'Pitting' && fieldSetVisible()"
  >
    <legend
      class="subtitle-4 float-none w-auto px-3"
      *ngIf="
        [0, 1, 2, 3].indexOf(component_mawp.strD_iclass) !== -1 &&
        component_mawp.strD_class !== 'Lamination'
      "
    >
      Metal Loss Information
    </legend>
    <legend
      class="subtitle-4 float-none w-auto px-3"
      *ngIf="component_mawp.strD_class === 'Lamination'"
    >
      Lamination Information
    </legend>
    <legend
      class="subtitle-4 float-none w-auto px-3"
      *ngIf="
        component_mawp.strD_iclass == 5 &&
        component_mawp.strD_class == 'Blister'
      "
    >
      Blister Information
    </legend>
    <legend
      class="subtitle-4 float-none w-auto px-3"
      *ngIf="
        component_mawp.strD_iclass == 5 && component_mawp.strD_class == 'HIC'
      "
    >
      HIC Information
    </legend>
    <legend
      class="subtitle-4 float-none w-auto px-3"
      *ngIf="
        component_mawp.strD_iclass == 8 &&
        component_mawp.strD_class == 'DentGouge'
      "
    >
      Dent-Gouge Combination Information
    </legend>
    <legend
      class="subtitle-4 float-none w-auto px-3"
      *ngIf="component_mawp.strD_iclass == 6"
    >
      Indication Information
    </legend>
    <legend
      class="subtitle-4 float-none w-auto px-3"
      *ngIf="component_mawp.strD_iclass === 7"
    >
      Dent Information
    </legend>
    <div class="container">
      <div *ngIf="validation_list.length > 0">
        <validation
          *ngIf="
            component_mawp.strD_iclass != 7 && component_mawp.strD_iclass != 9
          "
          [ValidationList]="validation_list"
        ></validation>
        <validation
          *ngIf="[7, 9].indexOf(component_mawp.strD_iclass) !== -1"
          [ValidationList]="validation_list"
          [ValidationLabel]="basicValidationLabel"
        ></validation>
      </div>
      <div
        class="form-group row align-items-center"
        *ngIf="component_mawp.strD_class === 'Lamination'"
      >
        <div class="col-sm-8 align-self-center">
          <label for="comboBox2_DI"
            >Multiple laminations at different elevations in through-thickness
            direction?</label
          >
        </div>
        <div class="col-sm-4">
          <select
            id="comboBox2_DI"
            class="form-control form-control-sm"
            (change)="onChangeComboBox2_DI($event.target.value)"
            formControlName="comboBox2_DI"
          >
            <option value="Initial" disabled selected hidden></option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </div>
      </div>
      <!-- Carlos Acero  07/09/24  -->
      <!-- Adding validation to hide select based on enhancement request -->
      <!-- https://dev.azure.com/chevron/Surface-Platform/_boards/board/t/SE-Application%20Support%20-%20Kanban/Stories/?workitem=7671147 -->
      <div *ngIf="component_mawp.strD_iclass !== 5 && component_mawp.strD_iclass !== 9">
        <div
          class="form-group row align-items-center"
          *ngIf="
            component_mawp.strD_iclass != 0 && component_mawp.strD_iclass != 6
          "
        >
          <div class="col-sm-8 align-self-center">
            <label
              for="comboBox1_DI"
              *ngIf="
                [0, 1, 2, 3, 4, 6].indexOf(component_mawp.strD_iclass) !== -1
              "
              >Any other thinned areas infringe on the 2s X 2c box?</label
            >
            <label for="comboBox1_DI" *ngIf="component_mawp.strD_iclass == 9"
              >Any major structural discountinuities or other laminations infringe
              on the 2s X 2c box?</label
            >
            <label for="comboBox1_DI" *ngIf="component_mawp.strD_iclass == 5"
              >Any other HIC or blister infringe on the 2s X 2c box?</label
            >
            <label
              for="comboBox1_DI"
              *ngIf="[7, 8].indexOf(component_mawp.strD_iclass) !== -1"
              >Measurement of the maximum depth of the dent in the pressurized
              condition is available?</label
            >
          </div>
          <div class="col-sm-4">
            <select
              id="comboBox1_DI"
              class="form-control form-control-sm"
              (change)="onChangeComboBox1_DI($event.target.value)"
              formControlName="comboBox1_DI"
            >
              <option value="Initial" disabled selected hidden></option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>
        </div>
      </div>
       <div class="form-group row align-items-center">
        <div class="col-sm-8 align-self-center">
          <label for="textBox3_DI" *ngIf="component_mawp.strD_iclass == 0"
            >Future corrosion allowance inside the damage area, FCAml
            &nbsp;<span *ngIf="this.intUnit === 0">(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label
            for="textBox3_DI"
            *ngIf="
              component_mawp.strD_iclass == 1 || component_mawp.strD_iclass == 3
            "
            >Length of the metal loss in the long. direction, s&nbsp;<span
              *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label for="textBox3_DI" *ngIf="component_mawp.strD_iclass == 2 && radiobuttonDI === 'radioButton2_DI_enabled'"
            >Metal loss length in the axial direction (0 to import data from CSV data), sp&nbsp;<span *ngIf="this.intUnit === 0">(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label for="textBox3_DI" *ngIf="component_mawp.strD_iclass == 2 && radiobuttonDI !== 'radioButton2_DI_enabled'"
            >Metal Loss data spacing in the axial direction (0 to import from CSV file), sp&nbsp;<span *ngIf="this.intUnit === 0">(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label for="textBox3_DI" *ngIf="component_mawp.strD_iclass == 9"
            >Lamination dimension in the circ. direction, c&nbsp;<span
              *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label
            for="textBox3_DI"
            *ngIf="[7].indexOf(component_mawp.strD_iclass) !== -1"
            >Dent spacing to the nearest major structure discontinuities,
            Lmsd&nbsp;<span *ngIf="this.intUnit === 0">(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label
            for="textBox3_DI"
            *ngIf="[8].indexOf(component_mawp.strD_iclass) !== -1"
            >Minimum measured thickness, tmm&nbsp;<span
              *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label
            for="textBox3_DI"
            *ngIf="
              component_mawp.strD_iclass == 5 &&
              component_mawp.strD_class == 'Blister'
            "
          >
            Minimum measured thickness including FCA as appropriate, tmm
            &nbsp;<span *ngIf="this.intUnit === 0">(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label
            for="textBox3_DI"
            *ngIf="
              component_mawp.strD_iclass == 5 &&
              component_mawp.strD_class == 'HIC'
            "
          >
            Minimum measured thickness HIC to ID including FCA as appropriate,
            tmm-ID&nbsp;<span *ngIf="this.intUnit === 0">(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label for="textBox3_DI" *ngIf="component_mawp.strD_iclass == 6"
            >Spacing between the indication and centerline of the weld, Lw
            <span *ngIf="this.intUnit === 0">(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
        </div>
        <div class="col-sm-4">
          <input
            appRestrictInput
            type="text"
            name="futureCorrosionAllowanceInsideDamageArea"
            (change)="onChangeTextBox3_DI($event)"
            [value]="lmlProfileData_sngGrid_spacing"
            (input)="onInput_lmlProfileData_sngGrid_spacing($event)"
            id="textBox3_DI"
            class="form-control form-control-sm"
            formControlName="textBox3_DI"           
            (paste)="utility_service.onPaste($event)"
            autocomplete="off"
          />
            <!-- Remove Decimal Number validation -->
          <!-- (keypress)="utility_service.decimalFilter($event, 3)" -->
        </div>
      </div>
      <div class="form-group row align-items-center">
        <div class="col-sm-8 align-self-center">
          <label for="textBox1_DI" *ngIf="component_mawp.strD_iclass == 0"
            >Average measured thickness, tam&nbsp;<span
              *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label
            for="textBox1_DI"
            *ngIf="
              component_mawp.strD_iclass == 1 || component_mawp.strD_iclass == 3
            "
          >
            Minimum measured thickness, tmm&nbsp;<span
              *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label for="textBox1_DI" *ngIf="component_mawp.strD_iclass == 2"
            >Total number of thickness readings in the longitudinal direction including the bounding readings in 
            sound metal adjacent to the LML region, n:</label
          >
          <label for="textBox1_DI" *ngIf="component_mawp.strD_iclass == 9"
            >Minimum measured thickness including FCA as appropriate,
            tmm&nbsp;<span *ngIf="this.intUnit === 0">(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label
            for="textBox1_DI"
            *ngIf="
              component_mawp.strD_iclass == 5 &&
              component_mawp.strD_class == 'Blister'
            "
            >Longitudinal extend of the blister, s&nbsp;<span
              *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label
            for="textBox1_DI"
            *ngIf="
              component_mawp.strD_iclass == 5 &&
              component_mawp.strD_class == 'HIC'
            "
            >Longitudinal extend of the HIC, s&nbsp;<span
              *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label for="textBox1_DI" *ngIf="component_mawp.strD_iclass == 6"
            >Indication depth, a &nbsp;<span *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label
            for="textBox1_DI"
            *ngIf="
              [7, 8].indexOf(component_mawp.strD_iclass) !== -1 &&
              DentInPressurizedCondition()
            "
            >Maximum depth of the dent in the pressurized condition,
            d_dp&nbsp;<span *ngIf="this.intUnit === 0">(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label
            for="textBox1_DI"
            *ngIf="
              [7, 8].indexOf(component_mawp.strD_iclass) !== -1 &&
              !DentInPressurizedCondition()
            "
            >Maximum depth of the dent in the un-pressurized condition,
            d_d0&nbsp;<span *ngIf="this.intUnit === 0">(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
        </div>
        <div class="col-sm-4">
          <input
            appRestrictInput
            type="number"
            name="aMeasuredThickness"
            (change)="onChangeTextBox1_DI($event)"
            [value]="lmlProfileData_intnum_t_pt"
            (input)="onInput_lmlProfileData_intnum_t_pt($event)"
            (keypress)="
              component_mawp.strD_iclass == 2
                ? utility_service.integerFilter($event)
                : null
            "
            (paste)="
              component_mawp.strD_iclass == 2 &&
                !utility_service.onPasteInteger($event) &&
                $event.preventDefault()
            "
            id="textBox1_DI"
            class="form-control form-control-sm"
            formControlName="textBox1_DI"
            min="0"
          />
        </div>
      </div>
      <div class="form-group row align-items-center">
        <div class="col-sm-8 align-self-center">
          <label for="textBox2_DI" *ngIf="component_mawp.strD_iclass == 0"
            >Minimum measured thickness, tmm&nbsp;<span
              *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label
            for="textBox2_DI"
            *ngIf="
              component_mawp.strD_iclass == 1 ||
              component_mawp.strD_iclass == 2 ||
              component_mawp.strD_iclass == 3
            "
            >Future corrosion allowance inside the damage area, FCAml
            &nbsp;<span *ngIf="this.intUnit === 0">(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label for="textBox2_DI" *ngIf="component_mawp.strD_iclass == 9"
            >Lamination dimension in the long. direction, s&nbsp;<span
              *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label
            for="textBox2_DI"
            *ngIf="[7].indexOf(component_mawp.strD_iclass) !== -1"
            >Dent spacing to the nearest weld joint, Lw&nbsp;<span
              *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label
            for="textBox2_DI"
            *ngIf="[8].indexOf(component_mawp.strD_iclass) !== -1"
            >Maximum depth of the gouge, d_g&nbsp;<span
              *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label
            for="textBox2_DI"
            *ngIf="
              component_mawp.strD_iclass == 5 &&
              component_mawp.strD_class == 'Blister'
            "
            >Circumferential extent of the blister, c&nbsp;<span
              *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label
            for="textBox2_DI"
            *ngIf="
              component_mawp.strD_iclass == 5 &&
              component_mawp.strD_class == 'HIC'
            "
            >Circumferential extent of the HIC, c&nbsp;<span
              *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label for="textBox2_DI" *ngIf="component_mawp.strD_iclass == 6"
            >Indication length, 2c &nbsp;<span *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
        </div>
        <div class="col-sm-4">
          <input
            appRestrictInput
            type="number"
            name="textBox2_DI"
            (change)="onChangeTextBox2_DI($event)"
            id="textBox2_DI"
            class="form-control form-control-sm"
            formControlName="textBox2_DI"
            min="0"
          />
        </div>
      </div>
     
      <div
        class="form-group row align-items-center"
        *ngIf="component_mawp.strD_iclass == 6"
      >
        <div class="col-sm-8 align-self-center">
          <label for="comboBox1_DI" *ngIf="component_mawp.strD_iclass == 6"
            >Indication location:</label
          >
        </div>
        <div class="col-sm-4">
          <select
            id="comboBox1_DI"
            class="form-control form-control-sm"
            (change)="onChangeComboBox1_DI($event.target.value)"
            *ngIf="component_mawp.strD_iclass == 6"
            formControlName="comboBox1_DI"
          >
            <option value="0">Weld & HAZ</option>
            <option value="1">Base Metal</option>
          </select>
        </div>
      </div>
      <div
        class="form-group row align-items-center"
        *ngIf="component_mawp.strD_iclass == 6"
      >
        <div class="col-sm-8 align-self-center">
          <label
            for="comboBox2_DI"
            [ngClass]="this.comboBox2_DI_Enabled ? '' : 'disabled'"
            >Indication orientation to weld seam:</label
          >
        </div>
        <div class="col-sm-4">
          <select
            id="comboBox2_DI"
            class="form-control form-control-sm"
            (change)="onChangeComboBox2_DI($event.target.value)"
            *ngIf="component_mawp.strD_iclass == 6"
            formControlName="comboBox2_DI"
          >
            <option value="Parallel">Parallel</option>
            <option value="Perpendicular">Perpendicular</option>
          </select>
        </div>
      </div>
      <div
        class="form-group row align-items-center"
        *ngIf="
          component_mawp.strD_iclass != 0 || component_mawp.strD_iclass != 3
        "
      >
        <div class="col-sm-8 align-self-center">
          <label
            for="textBox4_DI_sngcc"
            *ngIf="[1, 2, 3, 4].indexOf(component_mawp.strD_iclass) !== -1 && !(this.radiobuttonDI === 'radioButton2_DI_enabled' && [1,2,3].indexOf(component_mawp.strD_iclass) !== -1)"
            >Length of the metal loss in the circ. direction, c&nbsp;<span
              *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label
            for="textBox5_DI_external"
            *ngIf="
              [1, 3].indexOf(component_mawp.strD_iclass) !== -1 &&
              radiobuttonDI === 'radioButton2_DI_enabled'
            "
          >
            Distance from the edge of the metal loss to the nearest stiffening ring, L_1&nbsp;
            <span *ngIf="this.intUnit === 0">(inch)</span>
            <span *ngIf="this.intUnit === 1">(mm)</span>:
          </label>
          <label
            for="textBox7_DI_external"
            *ngIf="
              [2].indexOf(component_mawp.strD_iclass) !== -1 &&
              radiobuttonDI === 'radioButton2_DI_enabled'
            "
          >
            Axial distance from one edge of the metal loss to the nearest stiffening ring, L_1&nbsp;
            <span *ngIf="this.intUnit === 0">(inch)</span>
            <span *ngIf="this.intUnit === 1">(mm)</span>:
          </label>

          


          <label for="textBox4_DI_sngcc" *ngIf="component_mawp.strD_iclass == 9"
            >Lamination height, Lh&nbsp;<span *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label
            for="textBox4_DI_sngcc"
            *ngIf="[7].indexOf(component_mawp.strD_iclass) !== -1"
            >Dent spacing to the nearest dent or dent-gouge combination,
            Ld&nbsp;<span *ngIf="this.intUnit === 0">(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label
            for="textBox4_DI_sngcc"
            *ngIf="[8].indexOf(component_mawp.strD_iclass) !== -1"
            >Future Corrosion Allowance inside the damage, FCAml&nbsp;<span
              *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label
            for="textBox4_DI_sngcc"
            *ngIf="
              component_mawp.strD_iclass == 5 &&
              component_mawp.strD_class == 'Blister'
            "
          >
            Blister projection, Bp&nbsp;<span *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label
            for="textBox4_DI_sngcc"
            *ngIf="
              component_mawp.strD_iclass == 5 &&
              component_mawp.strD_class == 'HIC'
            "
          >
            Minimum measured thickness from HIC to OD including FCA as
            appropriate, tmm-OD&nbsp;<span *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label
            for="textBox4_DI_sngcc"
            *ngIf="component_mawp.strD_iclass == 6"
            [ngClass]="this.textBox4_DI_Enabled ? '' : 'disabled'"
          >
            Distance between the indication and the nearest major structural
            discontinuity, Lmsd&nbsp;<span *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
        </div>
        <div
          class="col-sm-4"
          *ngIf="
            [1, 2, 3, 4, 5, 6, 7, 8, 9].indexOf(component_mawp.strD_iclass) !==
            -1
          "
        >
          <input *ngIf="!([1,2,3].indexOf(component_mawp.strD_iclass) !== -1 && radiobuttonDI === 'radioButton2_DI_enabled')"
            appRestrictInput
            type="number"
            name="futureCorrosionAllowanceInsideDamageArea"
            (change)="onChangeTextBox4_DI($event)"
            id="textBox4_DI_sngcc"
            class="form-control form-control-sm"
            formControlName="textBox4_DI"
            min="0"
          />
           <input  *ngIf="
              [1, 3].indexOf(component_mawp.strD_iclass) !== -1 &&
              radiobuttonDI === 'radioButton2_DI_enabled'
            "
            appRestrictInput
            type="number"
            name="futureCorrosionAllowanceInsideDamageArea"
            (change)="onChangeTextBox5_DI_external($event)"
            id="textBox5_DI_external"
            class="form-control form-control-sm"
            formControlName="textBox5_DI_external"
            min="0"
          />
          <input  *ngIf="
              [2].indexOf(component_mawp.strD_iclass) !== -1 &&
              radiobuttonDI === 'radioButton2_DI_enabled'
            "
            appRestrictInput
            type="number"
            name="futureCorrosionAllowanceInsideDamageArea"
            (change)="onChangeTextBox7_DI_external($event)"
            id="textBox7_DI_external"
            class="form-control form-control-sm"
            formControlName="textBox7_DI_external"
            min="0"
          />
           
        </div>
      </div>

        <div
        class="form-group row align-items-center"
        *ngIf="
          component_mawp.strD_iclass != 0 || component_mawp.strD_iclass != 3
        "
      >
 <div class="col-sm-8 align-self-center">  
          <label
        for="textBox6_DI_external"
        *ngIf="
          [1, 3].indexOf(component_mawp.strD_iclass) !== -1 &&
          radiobuttonDI === 'radioButton2_DI_enabled'
        "
      >
        Distance from the opposite edge of the metal loss to the other stiffening ring, L_2&nbsp;
        <span *ngIf="this.intUnit === 0">(inch)</span>
        <span *ngIf="this.intUnit === 1">(mm)</span>:
      </label>
      <label
        for="textBox8_DI_external"
        *ngIf="
          [2].indexOf(component_mawp.strD_iclass) !== -1 &&
          radiobuttonDI === 'radioButton2_DI_enabled'
        "
      >
        Axial distance from the opposite edge of the metal loss to the nearest adjacent stiffening ring, L_2&nbsp;
        <span *ngIf="this.intUnit === 0">(inch)</span>
        <span *ngIf="this.intUnit === 1">(mm)</span>:
      </label>
      </div>
      
      <div
          class="col-sm-4"
          *ngIf="
            [1, 2, 3, 4, 5, 6, 7, 8, 9].indexOf(component_mawp.strD_iclass) !==
            -1
          "
        >
        <input
          *ngIf="[1, 3].indexOf(component_mawp.strD_iclass) !== -1 && radiobuttonDI === 'radioButton2_DI_enabled'"
          appRestrictInput
          type="number"
          name="textBox6_DI_external"
          (change)="onChangeTextBox6_DI_external($event)"
          id="textBox6_DI_external"
          class="form-control form-control-sm"
          formControlName="textBox6_DI_external"
          min="0"
        />

          <input
          *ngIf="[2].indexOf(component_mawp.strD_iclass) !== -1 && radiobuttonDI === 'radioButton2_DI_enabled'"
          appRestrictInput
          type="number"
          name="textBox8_DI_external"
          (change)="onChangeTextBox8_DI_external($event)"
          id="textBox8_DI_external"
          class="form-control form-control-sm"
          formControlName="textBox8_DI_external"
          min="0"
        />
        </div>
      </div>

      <div
        class="form-group row align-items-center"
        *ngIf="[0, 6].indexOf(component_mawp.strD_iclass) === -1"
      >
        <div class="col-sm-8 align-self-center">
          <label
            for="textBox5_DI_sngLmsd"
            *ngIf="
              [0, 1, 2, 3, 4, 6].indexOf(component_mawp.strD_iclass) !== -1
            "
            >Distance from the edge of the metal loss to the nearest major
            structural discontinuity, Lmsd&nbsp;<span *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label
            for="textBox5_DI_sngLmsd"
            *ngIf="component_mawp.strD_iclass == 8"
            >Dent Gouge spacing to the nearest weld joint&nbsp;<span
              *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label
            for="textBox5_DI_sngLmsd"
            *ngIf="component_mawp.strD_iclass == 9"
            >Edge-to-edge spacing between laminations, Ls&nbsp;<span
              *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label
            for="textBox5_DI_sngLmsd"
            *ngIf="
              component_mawp.strD_iclass == 5 &&
              component_mawp.strD_class == 'Blister'
            "
          >
            Blister spacing to the nearest HIC or blister, Lb&nbsp;<span
              *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label
            for="textBox5_DI_sngLmsd"
            *ngIf="
              component_mawp.strD_iclass == 5 &&
              component_mawp.strD_class == 'HIC'
            "
          >
            HIC spacing to the nearest HIC or blister, Lh&nbsp;<span
              *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label
            for="textBox5_DI_sngLmsd"
            *ngIf="component_mawp.strD_iclass == 7"
            >Dent sharpest radius of curvature, rd&nbsp;<span
              *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
        </div>
        <div class="col-sm-4">
          <input
            appRestrictInput
            type="number"
            name="futureCorrosionAllowanceInsideDamageArea"
            (change)="onChangeTextBox5_DI($event)"
            id="textBox5_DI_sngLmsd"
            class="form-control form-control-sm"
            formControlName="textBox5_DI"
            min="0"
          />
        </div>
      </div>
      <div
        class="form-group row align-items-center"
        *ngIf="[0, 7, 6].indexOf(component_mawp.strD_iclass) === -1"
      >
        <div class="col-sm-8 align-self-center">
          <label
            for="textBox6_DI_snggr"
            *ngIf="
              [0, 1, 2, 3, 4, 6, 7].indexOf(component_mawp.strD_iclass) !== -1
            "
            [ngClass]="{
              disabled:
                this.inspectionDataFormGroup.controls.textBox6_DI_snggr.disabled
            }"
            >Radius at the base of the groove-like flaw, gr&nbsp;<span
              *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label for="textBox6_DI_snggr" *ngIf="component_mawp.strD_iclass == 9"
            >Lamination spacing to the nearest weld joint, Lw&nbsp;<span
              *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label
            for="textBox6_DI_snggr"
            *ngIf="
              component_mawp.strD_iclass == 5 &&
              component_mawp.strD_class == 'Blister'
            "
          >
            Blister spacing to the nearest weld joint. Lw&nbsp;<span
              *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label for="textBox6_DI_snggr" *ngIf="component_mawp.strD_iclass == 8"
            >Dent Gouge spacing to the nearest major structure discontinuities,
            Lmsd&nbsp;<span *ngIf="this.intUnit === 0">(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label
            for="textBox6_DI_snggr"
            *ngIf="
              component_mawp.strD_iclass == 5 &&
              component_mawp.strD_class == 'HIC'
            "
          >
            HIC spacing to the nearest weld joint, Lw&nbsp;<span
              *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
        </div>
        <div class="col-sm-4">
          <input
            appRestrictInput
            type="number"
            name="futureCorrosionAllowanceInsideDamageArea"
            (change)="onChangeTextBox6_DI($event)"
            formControlName="textBox6_DI_snggr"
            id="textBox6_DI_snggr"
            class="form-control form-control-sm"
            min="0"
          />
        </div>
      </div>

      <div
        class="form-group row align-items-center"
        *ngIf="[9, 8].indexOf(component_mawp.strD_iclass) !== -1"
      >
        <div class="col-sm-8 align-self-center">
          <label for="textBox7_DI_sngHf" *ngIf="component_mawp.strD_iclass == 9"
            >Distance from the edge of the metal loss to the nearest major
            structural discontinuity, Lmsd&nbsp;<span *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label for="textBox7_DI_sngHf" *ngIf="component_mawp.strD_iclass == 8"
            >Dent Gouge spacing to the nearest dent or dent-gouge combination,
            Ld&nbsp;<span *ngIf="this.intUnit === 0">(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
        </div>
        <div class="col-sm-4">
          <input
            appRestrictInput
            type="number"
            name="distanceBetweenBottomFlawAndTankBottom"
            (change)="onChangeTextBox7_DI($event)"
            formControlName="textBox7_DI_sngHf"
            class="form-control form-control-sm"
            id="textBox7_DI_sngHf"
            min="0"
          />
        </div>
      </div>
      <div
        class="form-group row align-items-center"
        *ngIf="[5].indexOf(component_mawp.strD_iclass) !== -1"
      >
        <div class="col-sm-8 align-self-center">
          <label
            for="textBox7_DI"
            *ngIf="
              component_mawp.strD_iclass == 5 &&
              component_mawp.strD_class == 'Blister'
            "
          >
            Blister spacing to the nearest major structural discontinuity, Lmsd
            &nbsp;<span *ngIf="this.intUnit === 0">(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
          <label
            for="textBox7_DI"
            *ngIf="
              component_mawp.strD_iclass == 5 &&
              component_mawp.strD_class == 'HIC'
            "
          >
            HIC spacing to the nearest major structural discountinuity, Lmsd
            &nbsp;<span *ngIf="this.intUnit === 0">(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
        </div>
        <div class="col-sm-4">
          <input
            appRestrictInput
            type="number"
            name="futureCorrosionAllowanceInsideDamageArea"
            (change)="onChangeTextBox7_DI($event)"
            id="textBox7_DI"
            class="form-control form-control-sm"
            formControlName="textBox7_DI"
            min="0"
          />
        </div>
      </div>
      <div
        class="form-group row align-items-center"
        *ngIf="[8].indexOf(component_mawp.strD_iclass) !== -1"
      >
        <div class="col-sm-8 align-self-center">
          <label for="textBox8_DI" *ngIf="component_mawp.strD_iclass == 8">
            Radius at the base of the Dent-Gouge Combination, gr &nbsp;<span
              *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
        </div>
        <div class="col-sm-4">
          <input
            appRestrictInput
            type="number"
            name="radiusAtTheBaseOfDentGouge"
            (change)="onChangeTextBox8_DI($event)"
            id="textBox8_DI"
            class="form-control form-control-sm"
            formControlName="textBox8_DI"
            min="0"
          />
        </div>
      </div>
      <div
        class="form-group row align-items-center"
        *ngIf="[8].indexOf(component_mawp.strD_iclass) !== -1"
      >
        <div class="col-sm-8 align-self-center">
          <label for="textBox9_DI" *ngIf="component_mawp.strD_iclass == 8">
            Dent sharpest radius of curvature, rd &nbsp;<span
              *ngIf="this.intUnit === 0"
              >(inch)</span
            ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
          >
        </div>
        <div class="col-sm-4">
          <input
            appRestrictInput
            type="number"
            name="dentSharpestRadius"
            (change)="onChangeTextBox9_DI($event)"
            id="textBox9_DI"
            formControlName="textBox9_DI"
            class="form-control form-control-sm"
            min="0"
          />
        </div>
      </div>
      <div
        class="form-group row align-items-center"
        *ngIf="[5].indexOf(component_mawp.strD_iclass) !== -1"
      >
        <div class="col-sm-8 align-self-center">
          <label
            for="comboBox2_DI_BlisterHIC"
            *ngIf="
              component_mawp.strD_iclass == 5 &&
              component_mawp.strD_class == 'Blister'
            "
            >Periphery cracks towards ID or OD surface?</label
          >
          <label
            for="comboBox2_DI_BlisterHIC"
            *ngIf="
              component_mawp.strD_iclass == 5 &&
              component_mawp.strD_class == 'HIC'
            "
            >H2 charging is stopped by coating, overlay or process
            change?</label
          >
        </div>
        <div class="col-sm-4">
          <select
            id="comboBox2_DI_BlisterHIC"
            class="form-control form-control-sm"
            (change)="onChangeComboBox2_DI($event.target.value)"
            formControlName="comboBox2_DI_BlisterHIC"
          >
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </div>
      </div>
      <div
        class="form-group row align-items-center"
        *ngIf="
          (component_mawp.strD_iclass == 5 &&
            component_mawp.strD_class == 'Blister') ||
          component_mawp.strD_iclass == 6
        "
      >
        <div class="col-sm-8 align-self-center">
          <label
            for="comboBox3_DI"
            *ngIf="
              component_mawp.strD_iclass == 5 &&
              component_mawp.strD_class == 'Blister'
            "
            >Blister vented (crown crack or vent hole)?</label
          >
          <label for="comboBox3_DI" *ngIf="component_mawp.strD_iclass == 6"
            >Qualified NDE procedures and personnel are used to size the depth
            of the indication:</label
          >
        </div>
        <div class="col-sm-4">
          <select
            id="comboBox3_DI"
            class="form-control form-control-sm"
            (change)="onChangeComboBox3_DI($event.target.value)"
            formControlName="comboBox3_DI"
          >
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </div>
      </div>
    </div>
  </fieldset>

  <fieldset
    class="border rounded-3 p-3"
    *ngIf="component_mawp.strD_class === 'Pitting'"
  >
    <legend class="subtitle-4 float-none w-auto px-3">
      Pitting information
    </legend>
    <div *ngIf="validation_list.length > 0">
      <validation
        [ValidationList]="validation_list"
        [ValidationLabel]="basicValidationLabel"
      >
      </validation>
      <br />
    </div>
    <pitting-information
      [inspectionDataCalcCallValidationsInPitting]="
        inspectionDataCalculateCallValidationsInPitting
      "
      (updateValidationsStatus)="onUpdateValidationsStatus($event)"
    >
    </pitting-information>
  </fieldset>
</form>
